import React from 'react';
import PropTypes from 'prop-types';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".styles_textContainer__3Wl4q{\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  transform: scaleX(-1);\n  display: inline-block;\n}\n.styles_textItem__2sCYH{\n  transform: scaleX(-1);\n  display: inline-block;\n}\n";
var styles = { "textContainer": "styles_textContainer__3Wl4q", "textItem": "styles_textItem__2sCYH" };
styleInject(css);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var ReverseEllipsis = function ReverseEllipsis(_ref) {
  var text = _ref.text,
      style = _ref.style,
      maxWidth = _ref.maxWidth,
      className = _ref.className;

  var textReversed = text.split('').reverse().map(function (item, idx) {
    return item === ' ' ? React.createElement('span', {
      key: idx,
      className: styles.textItem,
      dangerouslySetInnerHTML: { __html: '&nbsp;' }
    }) : React.createElement(
      'span',
      {
        key: idx,
        className: styles.textItem
      },
      item
    );
  });

  return React.createElement(
    'div',
    {
      style: _extends({ maxWidth: maxWidth }, style),
      className: styles.textContainer + ' ' + className
    },
    textReversed
  );
};

ReverseEllipsis.propTypes = {
  text: PropTypes.string,
  style: PropTypes.object,
  maxWidth: PropTypes.number.isRequired,
  className: PropTypes.string
};

ReverseEllipsis.defaultProps = {
  text: '',
  style: {},
  className: ''
};

export default ReverseEllipsis;
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 18
// module chunks = 0